export const truncateDescription = (description, letterLimit) => {
    if (typeof description !== 'string') {
        return description;
    }
    if (description.length <= letterLimit) {
        return description;
    }
    return description.slice(0, letterLimit) + '...';
};
